import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { VersionService } from '@core/services/version.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-version-display',
  template: `
    <div class="version-display" *ngIf="version$ | async as version">
      <span class="version-label">Version:</span>
      <span class="version-value">{{ version }}</span>
    </div>
  `,
  styles: [`
    .version-display {
      position: fixed;
      bottom: 8px;
      left: 8px;
      background: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 11px;
      font-family: 'Roboto', sans-serif;
      z-index: 100;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .version-label {
      opacity: 0.8;
    }

    .version-value {
      font-weight: 500;
      font-family: 'Roboto Mono', monospace;
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
      .version-display {
        bottom: 4px;
        left: 4px;
        font-size: 10px;
        padding: 3px 6px;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionDisplayComponent implements OnInit {
  version$: Observable<string>;

  constructor(private versionService: VersionService) {}

  ngOnInit(): void {
    this.version$ = this.versionService.getCurrentVersion();
  }
}
